import { Config } from '@nw/shared/config';

export const UNLEASH_STORAGE_KEY = 'unleash-toggles';

const UNLEASH_URL = 'https://us.app.getunleash.io/uspp0156/api/frontend/';
const UNLEASH_APP_NAME = 'niat-application-portal';

const getCachedToggles = () => {
  try {
    const cached = localStorage.getItem(UNLEASH_STORAGE_KEY);
    return cached ? JSON.parse(cached) : [];
  } catch {
    return [];
  }
};

const cachedToggles = getCachedToggles();

export const unleashConfig = {
  url: UNLEASH_URL,
  clientKey: Config.UNLEASH_CLIENT_KEY,
  appName: UNLEASH_APP_NAME,
  environment: Config.UNLEASH_ENVIRONMENT,
  refreshInterval: 0,
  impressionDataAll: true,
  ...(cachedToggles.length > 0
    ? { bootstrap: cachedToggles, bootstrapOverride: false }
    : {}),
};

export const NAT_SLOT_VARIANT_FORM_KEY = 'DYNAMIC_NAT_SLOT_BOOKING_VARIANT';
export const NAT_INSTANT_SLOT_VARIANT = 'instant-plus-sunday';
export const APPLICATION_FEE_NAT_SLOT_PREVIEW =
  'application_fee_nat_slot_preview';
export const APPLICATION_FEE_NAT_SLOT_PREVIEW_ENABLED_VARIANT =
  'application-fee-slot-enabled';
export const APPLICATION_FEE_NAT_SLOT_PREVIEW_DISABLED_VARIANT =
  'application-fee-slot-disabled';

export const ADDITIONAL_PERSONAL_DETAILS_SECTION =
  'additional-personal-details-section';
export const ENABLE_ADDITIONAL_DETAILS_SECTION =
  'enable-additional-details-section';
export const DISABLED_ADDITIONAL_DETAILS_SECTION =
  'disabled-additional-details-section';
